import React from "react";
import Nav from "./Nav";
import ServerDownBanner from "./ServerDownBanner";

const Header = () => {
  // You can control this state based on your server status
  const isServerDown = false; // Set to true when server is down

  return (
    <>
      <section>
        <div className="main-container bg-white">
          <div className="content-container py-[2px] px-[10px] sm:px-[50px] md:px-[100px]">
            <img
              src="/sac-state-logo-3color.svg"
              alt="Sacramento State Logo"
              className="h-[50px]"
            />
          </div>
        </div>
        <ServerDownBanner isVisible={isServerDown} />
        <Nav />
      </section>
    </>
  );
};

export default Header;
